if (!customElements.get('product-form')) {
	customElements.define('product-form', class ProductForm extends HTMLElement {
		constructor() {
			super();

			this.form = this.querySelector('form');
			this.form.querySelector('[name=id]').disabled = false;
			this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
			this.minicart = document.querySelector('mini-cart');
			this.eventContext = this.form.dataset.eventContext;
			this.hideErrors = this.dataset.hideErrors === 'true';
		}

      

		onSubmitHandler(event) {
			event.preventDefault();
			const submitButton = this.querySelector('[type="submit"]');
			if (submitButton.classList.contains('loading')) {
				return;
			}

			this.handleErrorMessage();

			submitButton.setAttribute('aria-disabled', true);
			submitButton.classList.add('loading');
			this.querySelector('.button-overlay-spinner').classList.remove('hidden');

			const config = fetchConfig('javascript');
			config.headers['X-Requested-With'] = 'XMLHttpRequest';
			delete config.headers['Content-Type'];

          
			const formData = new FormData(this.form);
			formData.append('sections', this.minicart.getSectionsToRender().map((section) => section.id));
			formData.append('sections_url', window.location.pathname);
			config.body = formData;
            
        

			fetch(`${routes.cart_add_url}`, config)
				.then((response) => response.json())
				.then((response) => {
					if (response.status) {
						publish(PUB_SUB_EVENTS.cartError, {
							source: 'product-form',
							productVariantId: formData.get('id'),
							errors: response.errors || response.description,
							message: response.message,
						});

						this.handleErrorMessage(response.description);
						this.minicart.updateSectionContents();
						return;
					}
                  
					this.minicart.renderContents(response);

					if (window.themeSettings.redirectToCart) {
						location.href = '/cart';
					} else {
						this.minicart.open(submitButton);
					}

					publish(PUB_SUB_EVENTS.cartItemAdd, {
						source: this.eventContext,
						items: response,
					});

                  
                  //code added by CSS
                  if(response && response.id){
                    AddProductIntoCart(response.id,this);
                  }

                  
				})
				.catch((e) => {
					console.error(e);
				})
				.finally(() => {
					submitButton.classList.remove('loading');
					submitButton.removeAttribute('aria-disabled');
					this.querySelector('.button-overlay-spinner').classList.add('hidden');
				});
		}

		handleErrorMessage(errorMessage = false) {
			if (this.hideErrors) {
				return;
			}

			this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form-error-message-wrapper');
			this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form-error-message');

			this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

			if (errorMessage) {
				this.errorMessage.textContent = errorMessage;
			}
		}
	});
}

//code added by CSS Team
function AddProductIntoCart(variantIdAdded,_this){
  
try{
  let variantIdArray = [];
          $("input[type='number'][id^='quant_']:visible").each(function(){
        if(this.value!=0 && variantIdAdded != null && this.id.substring(6) != undefined && this.id.substring(6) != null && this.id.substring(6) != "" && this.id.substring(6) != variantIdAdded){
          var ProductId=this.id.substring(6);
          variantIdArray.push({"id": parseInt(ProductId), "quantity": parseInt(this.value)});
        }
      });
      
      let variantDataObj={
        "items": variantIdArray
      }
      
       $.ajax({
         type: 'POST',
         url: '/cart/add.js',
         dataType: 'json',
         data: variantDataObj,
         success: function (res) {
         	console.log("products added");
           $.ajax({
               type: 'GET',
               url: '/cart',
               dataType: 'json',
               success: function (cartItems) {
                 console.log(cartItems);
                 _this.minicart.updateSectionContents();
               }
            });
       	 }            
       });
}
catch(ex){
    console.log(ex);
  }
}